import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var VehicleDetailsRes;
export const VehicleDetailsTodo = createAsyncThunk('VehicleDetails', async (id) => {
    // console.log("data", data)
    try {
        const res = await axios({
            method: "Get",
            url: process.env.REACT_APP_API_URL + `vehicle_master/${id}`,
            headers: { "Content-Type": "application/json", "Authorization": 'Bearer ' + localStorage.getItem('user_token') }
        })
        return VehicleDetailsRes = res.data

    } catch (error) {
        return VehicleDetailsRes = error.response.data
    }
})

const VehicleDetailsSlice = createSlice({
    name: 'VehicleDetails',
    initialState: {
        data: null,
    },
    extraReducers: (builder) => {
        builder.addCase(VehicleDetailsTodo.fulfilled, (state, action) => {
            state.data = action.payload;
            // console.log('equipmentList', state.data.response)
        });
        builder.addCase(VehicleDetailsTodo.rejected, (state, action) => {
            // console.log('token_error', action)
        })
    }
});

export default VehicleDetailsSlice.reducer; 